module.exports = __webpack_public_path__ + "img/ico-card.69d4d80f.svg";